import React, { ElementType, ReactNode } from "react";

const sizes: Record<string, string> = {
  label_medium: "font-upheavalttbrk text-[24px] font-normal lg:text-[20px] md:text-[22px]",
  display_title_smallest: "font-upheavalttbrk text-[32px] font-normal lg:text-[27px] md:text-[30px] sm:text-[28px]",
  text2xl: "text-[16px] font-normal lg:text-[13px]",
  text3xl: "text-[17px] font-normal lg:text-[14px]",
  text4xl: "text-[20px] font-normal lg:text-[17px]",
  text6xl: "text-[28px] font-normal lg:text-[23px] md:text-[26px] sm:text-[24px]",
  text7xl: "text-[36px] font-normal lg:text-[30px] md:text-[34px] sm:text-[32px]",
  text8xl: "text-[40px] font-normal lg:text-[34px] md:text-[38px] sm:text-[36px]",
};

type TextProps = {
  children: ReactNode;
  className?: string;
  as?: ElementType;
  size?: keyof typeof sizes;
} & React.HTMLAttributes<HTMLElement>;

const Text: React.FC<TextProps> = ({
  children,
  className = "",
  as,
  size = "display",
  ...restProps
}) => {
  const Component = as || "p";
  return (
    <Component className={`text-lime-50_cc font-upheavalttbrk font-upheaval ${className} ${sizes[size]}`} {...restProps}>
      {children}
    </Component>
  );
};

export default Text;
